module.exports = __webpack_public_path__ + "assets/img/00155.4c3aae16.png";